'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Editable = require('apollo-cms/lib/DataView/Object/Editable');

var _Editable2 = _interopRequireDefault(_Editable);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _materialUi = require('material-ui');

var _Stop = require('material-ui-icons/Stop');

var _Stop2 = _interopRequireDefault(_Stop);

var _Grid = require('@prisma-cms/front/lib/modules/ui/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    root: {}
  };
};

var TimerView = (_temp = _class = function (_EditableView) {
  _inherits(TimerView, _EditableView);

  function TimerView() {
    _classCallCheck(this, TimerView);

    return _possibleConstructorReturn(this, _EditableView.apply(this, arguments));
  }

  TimerView.prototype.canEdit = function canEdit() {
    var currentUser = this.context.user;

    var _ref = currentUser || {},
        currentUserId = _ref.id,
        sudo = _ref.sudo;

    var _ref2 = this.getObjectWithMutations() || {},
        id = _ref2.id,
        CreatedBy = _ref2.CreatedBy;

    var _ref3 = CreatedBy || {},
        createdById = _ref3.id;

    return !id || createdById && createdById === currentUserId || sudo === true;
  };

  TimerView.prototype.getButtons = function getButtons() {
    var _this2 = this;

    var canEdit = this.canEdit(); // if (!canEdit) {
    //   return null;
    // }

    var _ref4 = this.getObjectWithMutations() || {},
        timerId = _ref4.id,
        stopedAt = _ref4.stopedAt;

    if (!timerId || stopedAt) {
      return null;
    }

    var buttons = [];
    buttons.push(_react2.default.createElement(_materialUi.IconButton, {
      key: 'stop',
      onClick: function onClick() {
        return _this2.stopTimer(timerId);
      },
      disabled: !canEdit
    }, _react2.default.createElement(_Stop2.default, null)));
    return buttons;
  };

  TimerView.prototype.stopTimer = function () {
    var _ref5 = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee(timerId) {
      var mutate;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              mutate = this.props.mutate;
              _context.next = 3;
              return mutate({
                variables: {
                  where: {
                    id: timerId
                  },
                  data: {
                    stopedAt: new Date()
                  }
                }
              });

            case 3:
              return _context.abrupt('return', _context.sent);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function stopTimer(_x) {
      return _ref5.apply(this, arguments);
    }

    return stopTimer;
  }();

  TimerView.prototype.save = function save() {
    var _context2 = this.context,
        currentUser = _context2.user,
        openLoginForm = _context2.openLoginForm;

    if (!currentUser) {
      return openLoginForm();
    }

    return _EditableView.prototype.save.call(this);
  };

  TimerView.prototype.getCacheKey = function getCacheKey() {
    var _ref6 = this.getObject() || {},
        id = _ref6.id;

    return 'timer_' + (id || "new");
  };

  TimerView.prototype.renderHeader = function renderHeader() {
    var _context3 = this.context,
        UserLink = _context3.UserLink,
        ProjectLink = _context3.ProjectLink,
        TaskLink = _context3.TaskLink;
    var classes = this.props.classes;
    var object = this.getObjectWithMutations();

    var _ref7 = object || {},
        timerId = _ref7.id,
        CreatedBy = _ref7.CreatedBy,
        createdAt = _ref7.createdAt,
        stopedAt = _ref7.stopedAt,
        Task = _ref7.Task;

    var _ref8 = Task || {},
        Project = _ref8.Project;

    var inEditMode = this.isInEditMode();
    return _react2.default.createElement('div', {
      className: classes.header
    }, _react2.default.createElement(_Grid2.default, {
      container: true,
      spacing: 16
    }, _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: true
    }, _react2.default.createElement(_Grid2.default, {
      container: true,
      alignItems: 'center'
    }, _react2.default.createElement(_Grid2.default, {
      item: true
    }, Task ? _react2.default.createElement(TaskLink, {
      object: Task
    }) : null, Project ? _react2.default.createElement('span', null, ' (', _react2.default.createElement(ProjectLink, {
      object: Project
    }), ')') : null), _react2.default.createElement(_Grid2.default, {
      item: true
    }, this.getButtons()), _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: true
    }), _react2.default.createElement(_Grid2.default, {
      item: true
    }, CreatedBy ? _react2.default.createElement(UserLink, {
      user: CreatedBy
    }) : null), createdAt ? _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: 12
    }, "\u041D\u0430\u0447\u0430\u043B\u043E: ", (0, _moment2.default)(createdAt).format('lll')) : null, stopedAt ? _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: 12
    }, "\u041A\u043E\u043D\u0435\u0446: ", (0, _moment2.default)(stopedAt).format('lll')) : null))));
  };

  TimerView.prototype.renderDefaultView = function renderDefaultView() {
    var classes = this.props.classes;
    var timer = this.getObjectWithMutations();

    if (!timer) {
      return null;
    }

    var content = timer.content;
    var inEditMode = this.isInEditMode();
    var allow_edit = this.canEdit();
    return _react2.default.createElement(_Grid2.default, {
      container: true
    }, _react2.default.createElement(_Grid2.default, {
      item: true
    }));
  };

  TimerView.prototype.renderEditableView = function renderEditableView() {
    return this.renderDefaultView();
  };

  TimerView.prototype.renderResetButton = function renderResetButton() {
    var _ref9 = this.getObjectWithMutations() || {},
        id = _ref9.id;

    return id ? _EditableView.prototype.renderResetButton.call(this) : null;
  };

  TimerView.prototype.render = function render() {
    var object = this.getObjectWithMutations();

    if (!object) {
      return null;
    }

    var classes = this.props.classes;
    return _react2.default.createElement('div', {
      className: classes.root
    }, _EditableView.prototype.render.call(this));
  };

  return TimerView;
}(_Editable2.default), _class.propTypes = _extends({}, _Editable2.default.propTypes, {
  classes: _propTypes2.default.object.isRequired
}), _class.defaultProps = _extends({}, _Editable2.default.defaultProps), _temp);
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(TimerView, props);
});
module.exports = exports['default'];